import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "@lottiefiles/dotlottie-wc";
import "./services/httpClient";
import App from "./App.jsx";
import { LeaderboardProvider } from "./contexts/LeaderboardContext";
import { SubjectsProvider } from "./contexts/SubjectsContext";
import { UserProvider } from "./contexts/UserContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { WorksheetProvider } from "./sse/WorksheetProvider.jsx";
import { SyllabusProvider } from "./contexts/SyllabusContext.jsx";
import * as Sentry from "@sentry/react";
import { GoogleOAuthProvider } from "@react-oauth/google";

/**
 * Sentry — development-friendly init for Vite/localhost
 * - Uses env DSN (VITE_SENTRY_DSN) so you don't hardcode secrets
 * - Marks env as import.meta.env.MODE ("development" on localhost)
 * - Debug logs enabled in dev
 * - Optional `tunnel` commented for when you want to proxy via your own backend
 * - Keeps Replay/Tracing; sample rates are reasonable for local testing
 */
const isDev = import.meta.env.MODE === "development";
const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  "966374653567-ik59fmg7b8nrl9biv55rlu6vgm3ak4vh.apps.googleusercontent.com";

// Sentry.init({
//   dsn: "https://aceebe086bb73c1215b45ca2007387f9@o4510080277610496.ingest.us.sentry.io/4510080280625152",
//   // tunnel: '/monitoring/tunnel', // <- if you proxy Sentry through your backend, uncomment

//   // Sentry.browserTracingIntegration(),
//   // integrations: [Sentry.replayIntegration()],

//   // // Performance & Replay sampling
//   // tracesSampleRate: 1.0, // full perf sampling in dev
//   // replaysSessionSampleRate: 0.1, // 10% sessions
//   // replaysOnErrorSampleRate: 1.0, // 100% when errors occur
//   maxBreadcrumbs: 50,

//   // Mark events as dev, enable verbose logs locally
//   environment: import.meta.env.MODE,
//   debug: isDev,

//   // Send default PII only if you intend to in dev as well
//   sendDefaultPii: true,

//   // Optional filters to reduce noise (customize as needed)
//   allowUrls: [location.origin],
//   denyUrls: [
//     /extensions\//i, // Chrome extensions
//     /^chrome:\/\//i, // Chrome internal
//   ],

//   // Make sure we don't accidentally drop events in dev
//   //ensures the payload size stays safe
//   beforeSend(event) {
//     try {
//       const MAX_LEN = 5000;
//       // Remove or truncate large fields
//       function sanitize(obj) {
//         if (!obj) return obj;
//         if (typeof obj === "string") {
//           return obj.length > MAX_LEN
//             ? obj.slice(0, MAX_LEN) + "…[truncated]"
//             : obj;
//         }
//         if (typeof obj === "object") {
//           const safe = Array.isArray(obj) ? [] : {};
//           for (const [k, v] of Object.entries(obj)) {
//             try {
//               safe[k] = sanitize(v);
//             } catch {
//               safe[k] = "[Unserializable]";
//             }
//           }
//           return safe;
//         }
//         return obj;
//       }

//       if (event.extra) event.extra = sanitize(event.extra);
//       if (event.contexts) event.contexts = sanitize(event.contexts);
//       if (event.request && event.request.data)
//         event.request.data = sanitize(event.request.data);

//       return event;
//     } catch (e) {
//       console.error("beforeSend failed", e);
//       return event; // never return undefined
//     }
//   },
//   tracePropagationTargets: ["localhost", "aanya.eduai.live"],
// });

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <UserProvider>
        <SyllabusProvider>
          <SidebarProvider>
            <LeaderboardProvider>
              <SubjectsProvider>
                <WorksheetProvider>
                  <App />
                </WorksheetProvider>
              </SubjectsProvider>
            </LeaderboardProvider>
          </SidebarProvider>
        </SyllabusProvider>
      </UserProvider>
    </GoogleOAuthProvider>
  </StrictMode>
);
